import styled from '@emotion/styled';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';
import { foldDealerModalSearch, setDealersModalFilter, unfoldDealerModalSearch } from 'modules/dealers/actions';
import { getFilters, isUnfoldedSearch } from 'modules/dealers/selectors/modalSelect';
import Button from 'ui/base/Button';
import SearchBase from 'ui/fields/SearchInput';

/** @type {SearchBase} */
const Search = styled(SearchBase)`
  width: 50% !important;

  > .ant-input {
    border: solid 1px #fff;
  }

  @media screen and (min-width: 768px) {
    max-width: initial;
  }

  @media screen and (max-width: 767px) {
    width: calc(80% - 20px) !important;
    margin-right: 20px;
  }
`;

const Header = styled.div`
  background-color: ${colors['@primary-color-dark']};
  padding: 32px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media screen and (max-width: 767px) {
    padding: 24px;
  }
`;

const unfoldStyle = css`
  @media screen and (max-width: 767px) {
    width: 20% !important;
    > span:not([class~="fb-icon"]) {
      display: none;
    }
  }
`;

const HeaderModal = () => {
  const ref = React.useRef();
  const dispatch = useDispatch();
  const isUnfold = useSelector(isUnfoldedSearch);
  const { text: value } = useSelector(getFilters);

  const handleToggleOnClick = React.useCallback(() => {
    const action = isUnfold ? foldDealerModalSearch : unfoldDealerModalSearch;
    dispatch(action());
  }, [dispatch, isUnfold]);

  /** @param {string} text */
  const handleOnSearch = React.useCallback(
    ({ target: { value: searchText } }) => {
      dispatch(setDealersModalFilter({ text: searchText }));
    },
    [dispatch]
  );

  React.useLayoutEffect(() => {
    ref.current?.focus();
  }, []);

  return (
    <Header>
      <Search
        ref={ref}
        value={value}
        onChange={handleOnSearch}
        placeholder="page.configurator.newOffer.notification.missingDealer"
      />
      <Button
        ghost
        iconPlacement="end"
        className={unfoldStyle}
        onClick={handleToggleOnClick}
        icon={<span className={classNames('fb-icon', { 'fb-icon--arrow-up': isUnfold, 'fb-icon--arrow-down': !isUnfold })} />}
      >
        <FormattedMessage id="page.home.filters.advanced" defaultMessage="Advanced filters" />
      </Button>
    </Header>
  );
};

export default HeaderModal;
